/**
 * @file contains keys for local storage key->value store
 */

export const KEY__FIRST_LOGIN = 'first-login';
export const KEY__FIRST_PAGE_VIEW = 'first-page-view';
export const KEY__DEVICE_ID = 'device-id';
